import { CommonModule, isPlatformBrowser } from "@angular/common";
import { ChangeDetectionStrategy, Component, Inject, InjectionToken, Injector, OnInit, PLATFORM_ID, runInInjectionContext, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NavigationEnd, Router, RouterModule } from "@angular/router";
import { PermissionNamesEnum } from "@server/services/cbox/public/api/v1/enforcers/entity_permission/types";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { CheckboxModule } from "primeng/checkbox";
import { DropdownModule } from "primeng/dropdown";
import { IconFieldModule } from "primeng/iconfield";
import { InputIconModule } from "primeng/inputicon";
import { InputTextModule } from "primeng/inputtext";
import { MenuModule } from "primeng/menu";
import { ProgressBarModule } from "primeng/progressbar";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { TableModule } from "primeng/table";
import { TabMenuModule } from "primeng/tabmenu";
import { TagModule } from "primeng/tag";
import { PermissionDirective } from "src/directives/permission.directive";
import { RedirectToRouteThatHasAccess } from "src/guards/permission.guard";
import { Routes } from "src/services/configuration/configuration.service";

@Component({
  selector: "app-cbox-profile-finance-billing-container",
  templateUrl: "./cbox-profile-finance-billing-container.component.html",
  styleUrls: ["./cbox-profile-finance-billing-container.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TabMenuModule,
    ButtonModule,
    RouterModule,
    MenuModule,
    TagModule,
    TableModule,
    CheckboxModule,
    CalendarModule,
    IconFieldModule,
    InputTextModule,
    InputIconModule,
    DropdownModule,
    ProgressSpinnerModule,
    ProgressBarModule,

    PermissionDirective
  ]
})

export class CBoxProfileFinanceBillingContainerComponent implements OnInit {
  tabMenuItems = signal<Routes[]>([
    {
      label: "Borderouri facturi",
      routerLink: "./pre-invoices",
      link: "./pre-invoices",
      icon: "receipt_long",
      description: "Borderouri de facturare (necesită aprobare)",
      rights: [PermissionNamesEnum.viewBillingPreInvoiceList],
    },
    {
      label: "Facturi",
      routerLink: "./list",
      link: "./list",
      icon: "receipt_long",
      description: "Facturi emise",
      rights: [PermissionNamesEnum.viewBillingInvoiceList],
    }
  ]);

  constructor(
    private router: Router,
    private inj: Injector,
    @Inject(PLATFORM_ID) private platformId: InjectionToken<Object>
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.router.events.pipe(takeUntilDestroyed())
        .subscribe((event) => {
          if (
              event instanceof NavigationEnd &&
              this.router.url.endsWith("/finance/invoices")
            ) {
              runInInjectionContext(this.inj, () => {
                RedirectToRouteThatHasAccess(
                  "/profile/finance/invoices",
                  this.tabMenuItems()
                );
              });
            }
        });
        this.router.navigate([this.router.url]);
      }
  }

  ngOnInit(): void {}
}